// Three shops beside Kanemori. Keep the approved bright street-level neon treatment.
import type {HdBuilding} from '../../common/src/data';
import type {LightFn} from './hd-registry';
import {type G,K,HT,px,frame,bands,disc} from './hd-kit';
import {panel,label,fan,window} from './hd-hachi-study';
export const KANEMORI_SHOPS=['pachinko','konbini','izakaya'] as const;
export function paintKanemoriShops(g:G,b:HdBuilding,x:number,y:number,L:LightFn){
 if(!(KANEMORI_SHOPS as readonly string[]).includes(b.id))return;
 const w=b.w*HT,h=b.h*HT,fy=y+(b.h-b.face)*HT;
 g.save();g.beginPath();g.rect(x,y,w,h);g.clip();
 if(b.id==='pachinko'){
  panel(g,x+23,y+18,84,35,K.metalLo);fan(g,x+30,y+23);fan(g,x+66,y+23);
  bands(g,x+2,fy+2,w-4,60,K.wall,K.wallLo,6);
  label(g,'パチンコ',x+35,fy+4,w-70,K.pink,2);
  for(let j=0;j<7;j++){const xx=x+13+j*33;panel(g,xx,fy+34,27,27,K.metalLo);disc(g,xx+13,fy+46,8,9,j%2?K.amber:K.pink);disc(g,xx+13,fy+46,4,5,K.white);px(g,xx+5,fy+56,17,2,K.amber);}
  for(let j=15;j<w-12;j+=13)px(g,x+j,fy+29,3,2,K.warmHi);
 }else if(b.id==='konbini'){
  panel(g,x+25,y+20,77,34,K.metalLo);fan(g,x+31,y+24);fan(g,x+67,y+24);
  bands(g,x+2,fy+2,w-4,60,K.concrete,K.wallLo,6);
  label(g,'24H MART',x+58,fy+4,w-116,K.white,2);
  px(g,x+7,fy+28,w-14,3,K.pink);px(g,x+7,fy+31,w-14,2,K.white);
  for(const xx of [x+12,x+w-94]){window(g,xx,fy+37,82,24,K.amber);for(let row=0;row<2;row++){px(g,xx+3,fy+47+row*9,76,2,K.woodHi);for(let j=7;j<77;j+=10)px(g,xx+j,fy+40+row*9,5,6,j%3?K.white:K.pink);}}
  window(g,x+w/2-19,fy+35,38,27,K.amber);px(g,x+w/2-1,fy+37,2,23,K.metalLo);
  L(x+16,fy+49,w-32,10,K.amber,.36,true);
 }else{
  panel(g,x+29,y+18,96,33,K.metalLo);fan(g,x+35,y+22);px(g,x+68,y+31,116,10,K.metalLo);px(g,x+70,y+32,112,2,K.metalHi);
  bands(g,x+2,fy+2,w-4,60,K.woodHi,K.woodLo,6);
  label(g,'ヤキトリ',x+53,fy+4,w-106,K.amber,2);
  for(const xx of [x+15,x+w-89]){window(g,xx,fy+35,74,25,K.amber);px(g,xx+3,fy+54,68,3,K.woodHi);for(let j=9;j<68;j+=13){px(g,xx+j,fy+39,1,14,K.woodHi);for(let k=0;k<3;k++)px(g,xx+j-2,fy+40+k*4,5,3,K.amber);}}
  panel(g,x+w/2-22,fy+34,44,28,K.ink);for(let j=0;j<3;j++){px(g,x+w/2-20+j*14,fy+34,12,16,K.woodLo);px(g,x+w/2-18+j*14,fy+36,8,2,K.amber);}
  for(const xx of [x+7,x+w-8]){disc(g,xx,fy+43,5,8,K.amber);px(g,xx-3,fy+35,6,2,K.woodLo);}
 }
 frame(g,x+2,fy+2,w-4,60,K.ink);g.restore();
}
